import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button as ButtonIcon } from "@faire/web/slate/icons/foundation/Button";
import React from "react";
import { BrandReferralCreditDiscrepancyIA } from "../instantAnswers/referrals-brandReferralsCreditDiscrepancy";
import { BrandReferralEarnedCreditIA } from "../instantAnswers/referrals-brandReferralsEarnCredit";
import { BrandReferralHowDoReferralsWorkIA } from "../instantAnswers/referrals-brandReferralsHowDoReferralsWork";
import { BrandReferralHowToReferBrandIA } from "../instantAnswers/referrals-brandReferralsHowToReferBrand";
import { BrandReferralStatusIA } from "../instantAnswers/referrals-brandReferralsStatus";
import { BrandReferralUseCreditIA } from "../instantAnswers/referrals-brandReferralsUseCredit";
import { HowDoesSignupWorkIA } from "../instantAnswers/referrals-HowDoesSignupWork";
import { WhenDoesSignupExpireIA } from "../instantAnswers/referrals-whenDoesSignupExpire";
export var useReferralsRetailerNodes = function useReferralsRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Referrals: {
      id: "Referrals",
      label: strictLocalize({
        id: "M0WiVO",
        defaultMessage: "Referrals"
      }),
      icon: /*#__PURE__*/React.createElement(ButtonIcon, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE, articles.Referrals.USE_REFERRAL_PROMOTION],
      children: ["SignUpOfferFaireDirect", "ReferBrand"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "4+bbF4",
        defaultMessage: "Referral issue"
      })
    },
    SignUpOfferFaireDirect: {
      id: "SignUpOfferFaireDirect",
      label: strictLocalize({
        id: "o2g2nG",
        defaultMessage: "Signup offer (Faire Direct)"
      }),
      children: ["HowDoesSignupWork", "WhenDoesSignupExpire", "WhyNoSignupOffer"],
      level: 2
    },
    ReferBrand: {
      id: "ReferBrand",
      label: strictLocalize({
        id: "83wxuX",
        defaultMessage: "Refer a brand"
      }),
      children: ["BrandReferralsStatus", "BrandReferralsEarnCredit", "BrandReferralsUseCredit", "CreditDiscrepancy", "HowToReferBrand", "HowBrandReferralsWork"],
      level: 2
    },
    HowDoesSignupWork: {
      id: "HowDoesSignupWork",
      label: strictLocalize({
        id: "FXEwMX",
        defaultMessage: "How does the signup offer work"
      }),
      articles: [articles.Referrals.USE_REFERRAL_PROMOTION],
      instantAnswer: HowDoesSignupWorkIA(strictLocalize),
      level: 3
    },
    WhenDoesSignupExpire: {
      id: "WhenDoesSignupExpire",
      label: strictLocalize({
        id: "rd31e3",
        defaultMessage: "When does my signup offer expire"
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    },
    WhyNoSignupOffer: {
      id: "WhyNoSignupOffer",
      label: strictLocalize({
        id: "xqST3e",
        defaultMessage: "Why didn’t I get the signup offer"
      }),
      instantAnswer: WhenDoesSignupExpireIA(strictLocalize),
      level: 3
    },
    BrandReferralsStatus: {
      id: "BrandReferralsStatus",
      label: strictLocalize({
        id: "iSZLbz",
        defaultMessage: "How to check the status of brand referrals"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralStatusIA(strictLocalize),
      level: 3
    },
    BrandReferralsEarnCredit: {
      id: "BrandReferralsEarnCredit",
      label: strictLocalize({
        id: "KvS6i7",
        defaultMessage: "How to earn credit from brand referrals"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralEarnedCreditIA(strictLocalize),
      level: 3
    },
    BrandReferralsUseCredit: {
      id: "BrandReferralsUseCredit",
      label: strictLocalize({
        id: "7b3NED",
        defaultMessage: "How to use the credit from brand referrals"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralUseCreditIA(strictLocalize),
      level: 3
    },
    CreditDiscrepancy: {
      id: "CreditDiscrepancy",
      label: strictLocalize({
        id: "tKiExe",
        defaultMessage: "Why is there a credit discrepancy"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralCreditDiscrepancyIA(strictLocalize),
      level: 3
    },
    HowToReferBrand: {
      id: "HowToReferBrand",
      label: strictLocalize({
        id: "ENRJid",
        defaultMessage: "How to refer a brand"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE],
      instantAnswer: BrandReferralHowToReferBrandIA(strictLocalize),
      level: 3
    },
    HowBrandReferralsWork: {
      id: "HowBrandReferralsWork",
      label: strictLocalize({
        id: "Mvesm2",
        defaultMessage: "How do brand referrals work"
      }),
      articles: [articles.Referrals.CAN_I_REFER_BRANDS_TO_FAIRE, articles.FAQ.BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS],
      instantAnswer: BrandReferralHowDoReferralsWorkIA(strictLocalize),
      level: 3
    }
  };
};